<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="起始日">
                <a-date-picker
                  v-model:value="queryParam.startDate"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择起始日"
                  :disabled-date="disabledDateAfterToday"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="截止日">
                <a-date-picker
                  v-model:value="queryParam.endDate"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择截止日"
                  :disabled-date="disabledDateAfterToday"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="员工岗位">
                <a-input
                  v-model:value="queryParam.postName"
                  placeholder="请输入员工岗位"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="位置/空间名">
                <a-input
                  v-model:value="queryParam.spaceName"
                  placeholder="请输入位置/空间名"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="float: right; overflow: hidden">
                <a-button type="primary" @click="handleQuery">
                  <SearchOutlined />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <RedoOutlined />重置
                </a-button>
                <a-button
                  type="primary"
                  style="margin-left: 8px"
                  :loading="exportLoading"
                  @click="handleExport"
                  v-hasPermi="['system:userStayRecord:export']"
                >
                  <DownloadOutlined />导出
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table
        :loading="loading"
        rowKey="rowKey"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="false"
      />

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { $on, $off } from '../../../utils/gogocodeTransfer'
import { pagePersonnelTrajectory } from '@/api/system/userStayRecord'
import { parseTime } from '@/utils/ruoyi'
import { SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons-vue'

export default {
  name: 'PersonnelTrajectory',
  components: {
    SearchOutlined,
    RedoOutlined,
    DownloadOutlined,
  },
  data() {
    const today = moment().format('YYYY-MM-DD')
    return {
      loading: false,
      exportLoading: false,
      total: 0,
      list: [],
      queryParam: {
        projectId: undefined,
        startDate: today,
        endDate: today,
        postName: undefined,
        spaceName: undefined,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '员工岗位',
          dataIndex: 'postName',
          ellipsis: true,
          customRender: ({ text }) => (text != null && text !== '' ? text : '-'),
        },
        {
          title: '空间名',
          dataIndex: 'spaceName',
          ellipsis: true,
          customRender: ({ text }) => (text != null && text !== '' ? text : '-'),
        },
        {
          title: '进入时间',
          dataIndex: 'entryTime',
          customRender: ({ text }) => parseTime(text) || '-',
        },
        {
          title: '离开时间',
          dataIndex: 'departureTime',
          customRender: ({ text }) => parseTime(text) || '-',
        },
        {
          title: '停留时间',
          dataIndex: 'stayDuration',
          width: 120,
          customRender: ({ text }) => (text != null && text !== '' ? text : '0.00'),
        },
      ],
    }
  },
  created() {
    this.initProjectId()
    this.getList()
  },
  activated() {
    this.getList()
  },
  mounted() {
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  methods: {
    disabledDateAfterToday(current) {
      if (!current) return false
      return current.isAfter(moment(), 'day')
    },
    initProjectId() {
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
    },
    handleProjectChanged(projectId) {
      this.queryParam.projectId = projectId || undefined
      this.queryParam.pageNum = 1
      this.getList()
    },
    buildQueryParams() {
      const params = {
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      }
      if (this.queryParam.projectId) {
        params.projectId = this.queryParam.projectId
      }
      if (this.queryParam.startDate) {
        params.startDate = this.queryParam.startDate
      }
      if (this.queryParam.endDate) {
        params.endDate = this.queryParam.endDate
      }
      if (this.queryParam.postName) {
        params.postName = this.queryParam.postName
      }
      if (this.queryParam.spaceName) {
        params.spaceName = this.queryParam.spaceName
      }
      return params
    },
    getList() {
      this.initProjectId()
      this.loading = true
      pagePersonnelTrajectory(this.buildQueryParams())
        .then((response) => {
          const data = response && response.data ? response.data : null
          const records = data && data.records ? data.records : []
          this.list = records.map((item, index) => ({
            ...item,
            rowKey:
              item.id != null
                ? `${item.id}_${item.dataSource || 'x'}`
                : `${item.employeeId || ''}_${item.entryTime || ''}_${index}`,
          }))
          this.total = data && data.total ? data.total : 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
          this.$message.error('获取人员轨迹失败', 3)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      const today = moment().format('YYYY-MM-DD')
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        projectId: currentProjectId || undefined,
        startDate: today,
        endDate: today,
        postName: undefined,
        spaceName: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.getList()
    },
    onShowSizeChange(current, size) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = size
      this.getList()
    },
    changeSize(page) {
      this.queryParam.pageNum = page
      this.getList()
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '将导出当前筛选条件下的人员轨迹数据',
        onOk() {
          that.exportLoading = true
          const params = that.buildQueryParams()
          return that
            .download(
              'system/user-stay-record/trajectory/export',
              params,
              `人员轨迹_${new Date().getTime()}.xlsx`
            )
            .finally(() => {
              that.exportLoading = false
            })
        },
        onCancel() {},
      })
    },
  },
}
</script>
